<template>
	<section>
		<compWrapper title="基本信息" theme="primary">
			<compFormEdit
				v-if="type!=='query'"
				class="margin-layout"
				ref="formbase"
				:formdata="getBase"
				v-model="formData"
				placeholder="--"
			></compFormEdit>
			<compFormQuery
				v-else
				class="margin-layout"
				:formdata="getBase"
				:value="formData"
				placeholder="--"
			></compFormQuery>
		</compWrapper>
		<compWrapper title="事务明细" theme="info">
			<compOrderitem
				:activeid="activeid"
				:querytype="querytype"
				:orgId="formData.organizationId"
				class="margin-layout"
				ref="workOrderItems"
			></compOrderitem>
			<vButtonGroup slot="footer" v-if="!querytype">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList"></compLog>
		</compWrapper>
		<vButtonGroup class="text-right" v-if="querytype">
			<vButton
				v-for="item in getStatusBtns"
				:key="item.name"
				@click="item.run"
				:theme="item.theme"
			>{{item.name}}</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="getDetail"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpWorkOrder, HttpSaveWorkOrder, HttpConfirmAndSaveWorkOrder, HttpCancelWorkOrder,HttpConfirmWorkOrder } from '@/service/workorder';
import mixin from "./mixin";
import compOrderitem from "./orderitem";
export default {
	props: ['activeid', 'querytype'],
	mixins: [mixin],
	components: {
		compOrderitem,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
			formData: {

			},
			// workOrderItems: [],
			logList: [],//log,
			modalProps: {
				show: false,
			}

		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getBillcusWareList']),
		/**
		 * 根据状态显示不同按钮
		 */
		getStatusBtns() {
			const workOrderStatus = this.formData.workOrderStatus
			const btn = [{
				name: '保存为草稿',
				theme: 'primary',
				show: this.type === 'edit',
				run: this.save
			}, {
				name: '保存并确认',
				theme: 'success',
				show: workOrderStatus == 0,
				run: this.confirm
			}, {
				name: '取消',
				theme: 'error',
				show: workOrderStatus == 0 && this.type === 'query',
				run: this.cancel
			}, {
				name: '返回',
				theme: 'default',
				show: true,
				run: this.goback
			}]
			return btn.filter(item => item.show);
		},

		getBase() {
			return [{
				label: "来源单号",
				key: "sourceNo",
				required: false,
			}, {
				label: "状态",
				key: "workOrderStatus",
				options: this.getOrderStatus,
				query: true,
			}, {
				label: "事务处理单号",
				key: "workOrderNo",
				query: true,
			},
			{
				label: "事务处理计划单号",
				key: "workOrderPlanNo",
				query: true,
			},
			{
				label: "关联单据类型",
				key: "relationOrderTypeId",
				options: this.getRelativeOrderTypes,
				query: true,
			},
			{
				label: "关联单据号",
				key: "orderNo",
				query: true,
			},
			{
				label: "客户组织",
				key: "organizationId",
				options: this.getSelfmanageorgList,
				query: true,
			},
			{
				label: "仓库",
				key: "orgWarehouseId",
				// options: this.getBillcusWareList,\
				valueText: `${this.formData.orgWarehouseCode || ''}(${this.formData.orgWarehouseTitle || ''})`,
				query: true,
			},
			{
				label: "项目",
				key: "lineId",
				options: this.getCusproductList,
				query: true,
			},
			{
				label: "备注",
				key: "remark",
				tag: 'vTextarea',
				required: false,
			},
			];
		},
	},
	methods: {
		//获取计划单详情
		getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpWorkOrder({ id: this.id }).then(res => {
				const data = res.data || {};
				this.loading = false;
				this.formData = data.serviceWorkOrder;
				this.logList = data.orderLogList;
				this.formData.serviceWorkOrderItemList = '';
				delete this.formData.serviceWorkOrderItemList;
				if (this.formData.lineId == 0) this.formData.lineId = '';
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},

		//更新单据数据
		async save(isConfirm) {
			// const valid = await this.$refs.formbase.validate();
			// if (!valid) return;
			this.loading = true;
			return HttpSaveWorkOrder(this.formData).then(res => {
				this.loading = false;
				return isConfirm !== true ? this.goback() : null;
			}).catch(err => {
				this.loading = false;
				if (isConfirm !== true) {
					this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
				} else {
					throw new Error(err);
				}
			})
		},
		//确认
		async confirm() {
			await this.save(true)
			this.modalProps = {
				show: true,
				alert: 'success',
				params: { id: this.id, ...this.formData },
				title: '确认',
				ajaxRequest: HttpConfirmWorkOrder,
				callback: this.goback,
				showDesc: false,
				formdata: [
					{
						label: '备注',
						tag: "vTextarea",
						key: 'reason',
						span: 24,
						labelWidth: 60,
						required: false
					}
				]
			}
		},
		//取消
		async cancel() {
			this.modalProps = {
				show: true,
				alert: 'error',
				params: { id: this.id },
				title: '取消',
				ajaxRequest: HttpCancelWorkOrder,
				callback: this.goback,
				showDesc: false,
				formdata: [
					{
						label: '备注',
						tag: "vTextarea",
						key: 'remark',
						span: 24,
						labelWidth: 60,
						required: false
					}
				]
			}
		},
		goback() {
			if (this.querytype) {
				this.$emit('on-close')
			} else {
				this.$router.push({
					name: 'workorderorder'
				})
			}
		}
	}
};
</script>
